import useGlobalStore from 'store/global';
import useStore from 'store/timeline';

const MakePostBox = ({
  className = '',
  from = '',
}: {
  className?: string;
  from?: string;
}) => {
  const currentUser = useStore((state) => state.currentUser);
  const showCreatePostDialog = useGlobalStore(
    (state) => state.showCreatePostDialog,
  );
  const showLogin = useGlobalStore((state) => state.showLogin);
  const createPostClick = () => {
    if (!currentUser) {
      showLogin({});
      return;
    }
    showCreatePostDialog({
      open: true,
    });
  };

  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white p-4 shadow-sm ${className}`}
    >
      <div className="flex items-center gap-3">
        {/* User Avatar */}
        <div className="shrink-0">
          <img
            src={currentUser?.avatar_url || '/images/icons/default-avatar1.png'}
            alt={currentUser?.name}
            className="size-10 rounded-full object-cover"
          />
        </div>

        {/* Post Input */}
        <div className="flex-1">
          <input
            type="text"
            placeholder="アイデアを共有しよう..."
            readOnly
            onClick={() => {
              createPostClick();
            }}
            className="w-full cursor-pointer rounded-full border bg-pp-bg-tertiary px-4 py-2 text-sm text-gray-600 transition-colors duration-200 placeholder:text-gray-500 hover:border-line-default hover:bg-pp-border-primary focus:outline-none"
          />
        </div>
      </div>
    </div>
  );
};

export default MakePostBox;
